<template>
  <!--新增api分类-->
  <x-addCategory></x-addCategory>
</template>

<script>
export default {
  name: 'addApiCate'
};
</script>

<style scoped>

</style>
